import { render, staticRenderFns } from "./paymentinfo.vue?vue&type=template&id=fd460a3c&scoped=true"
import script from "./paymentinfo.vue?vue&type=script&lang=js"
export * from "./paymentinfo.vue?vue&type=script&lang=js"
import style0 from "./paymentinfo.vue?vue&type=style&index=0&id=fd460a3c&prod&lang=css"
import style1 from "./paymentinfo.vue?vue&type=style&index=1&id=fd460a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd460a3c",
  null
  
)

export default component.exports